import React from 'react';
import { Users, BookCopy, Star, MapPin } from 'lucide-react';
export function TrustBar() {
  return <div className="w-full bg-mystic-800/50 border-y border-mystic-700/50 py-6 backdrop-blur-sm" data-id="element-302">
      <div className="max-w-6xl mx-auto px-4 flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-sm md:text-base text-slate-300 font-medium" data-id="element-303">
        <div className="flex items-center gap-2" data-id="element-304">
          <Users className="w-5 h-5 text-gold-400" data-id="element-305" />
          <span data-id="element-306">+500 mujeres transformando su energía</span>
        </div>
        <div className="hidden md:block w-1 h-1 rounded-full bg-mystic-600" data-id="element-307" />
        <div className="flex items-center gap-2" data-id="element-308">
          <BookCopy className="w-5 h-5 text-lilac-400" data-id="element-309" />
          <span data-id="element-310">12+6+2 Tomos + Bonus + Élite</span>
        </div>
        <div className="hidden lg:block w-1 h-1 rounded-full bg-mystic-600" data-id="element-311" />
        <div className="flex items-center gap-2" data-id="element-312">
          <Star className="w-5 h-5 text-gold-400 fill-gold-400" data-id="element-313" />
          <span data-id="element-314">4.9/5 calificación</span>
        </div>
        <div className="hidden lg:block w-1 h-1 rounded-full bg-mystic-600" data-id="element-315" />
        <div className="flex items-center gap-2" data-id="element-316">
          <MapPin className="w-5 h-5 text-lilac-400" data-id="element-317" />
          <span data-id="element-318">⭐ 🇦🇷 Argentina</span>
        </div>
      </div>
    </div>;
}